<div class="header">
  <header class="primary-bar d-flex flex-wrap align-items-center justify-content-between py-2 px-4">
    <div class="d-flex align-items-center gap-3">
      <a href="/" class="d-inline-flex link-body-emphasis text-decoration-none" (click)="goHome(); $event.preventDefault()">
        <img src="../../assets/images/landing/GeoAstra_logo_Transparent_black_Colors_1300x300.png" width="180" height="42" alt="GeoAstra Logo">
      </a>

      <button class="menu-toggle d-inline-flex d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#landingNav" aria-controls="landingNav" aria-label="Menu">
        <span class="material-icons">menu</span>
      </button>
    </div>

    <!-- Desktop primary nav: in-page product anchors only -->
    <ul class="nav primary-nav d-none d-lg-flex align-items-center mb-0">
      <li class="nav-item">
        <a class="nav-link" href="#" (click)="navigateTo('ntrip-caster-section'); $event.preventDefault()">Overview</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" (click)="navigateTo('ppk-studio-section'); $event.preventDefault()">PPK Studio</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" (click)="navigateTo('ppk-downloader-pro-section'); $event.preventDefault()">PPK Downloader</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" (click)="navigateTo('rtk-base-analyzer-pro-section'); $event.preventDefault()">RTK Base Analyzer</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" (click)="navigateTo('pricing-section'); $event.preventDefault()">Pricing</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#" (click)="navigateTo('stores-section'); $event.preventDefault()">Stores</a>
      </li>
    </ul>

    <!-- Exit to main GeoAstra site -->
    <div class="ms-auto d-flex align-items-center">
      <a class="geoastra-home-cta"
         [href]="mainSiteUrl || 'https://geoastra.com'"
         aria-label="Visit the GeoAstra company homepage">
        <span class="material-icons geoastra-home-cta-icon" aria-hidden="true">home</span>
        <span class="geoastra-home-cta-label">GeoAstra Home</span>
        <span class="material-icons geoastra-home-cta-arrow" aria-hidden="true">chevron_right</span>
      </a>
    </div>
  </header>
</div>

<!-- Offcanvas drawer for tablet/mobile -->
<div class="offcanvas offcanvas-start landing-offcanvas" tabindex="-1" id="landingNav" aria-labelledby="landingNavLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title" id="landingNavLabel">Menu</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <div class="nav flex-column">
      <a class="drawer-link" href="#" (click)="navigateTo('ntrip-caster-section'); $event.preventDefault()" data-bs-dismiss="offcanvas">Overview</a>
      <a class="drawer-link" href="#" (click)="navigateTo('ppk-studio-section'); $event.preventDefault()" data-bs-dismiss="offcanvas">PPK Studio</a>
      <a class="drawer-link" href="#" (click)="navigateTo('ppk-downloader-pro-section'); $event.preventDefault()" data-bs-dismiss="offcanvas">PPK Downloader</a>
      <a class="drawer-link" href="#" (click)="navigateTo('rtk-base-analyzer-pro-section'); $event.preventDefault()" data-bs-dismiss="offcanvas">RTK Base Analyzer</a>
      <a class="drawer-link" href="#" (click)="navigateTo('pricing-section'); $event.preventDefault()" data-bs-dismiss="offcanvas">Pricing</a>
      <a class="drawer-link" href="#" (click)="navigateTo('stores-section'); $event.preventDefault()" data-bs-dismiss="offcanvas">Stores</a>
      <div class="rail-divider"></div>
      <a class="drawer-home-cta"
         [href]="mainSiteUrl || 'https://geoastra.com'"
         aria-label="Visit the GeoAstra company homepage"
         data-bs-dismiss="offcanvas">
        <span class="material-icons drawer-home-icon" aria-hidden="true">home</span>
        <span class="drawer-home-label">GeoAstra Home</span>
        <span class="material-icons drawer-home-arrow" aria-hidden="true">chevron_right</span>
      </a>
    </div>
  </div>
</div>
